import React, { useContext, useState } from 'react';
import { IAppContext } from '../client';
import { BiLoggerService } from '../services/biLoggerService';

export const BiLoggerContext = React.createContext<{
  biLogger: BiLoggerService;
}>({
  biLogger: {} as BiLoggerService,
});

export const useBiLogger = () => {
  return useContext(BiLoggerContext);
};

export const BiLoggerProvider: React.FC<{
  appContext: IAppContext;
}> = ({ children, appContext }) => {
  const [biLogger] = useState(new BiLoggerService(appContext));
  return (
    <BiLoggerContext.Provider
      value={{
        biLogger,
      }}
    >
      {children}
    </BiLoggerContext.Provider>
  );
};
